import MonthPersonReport from './month-person-report.vue'
export default MonthPersonReport
